<template>
  <div class="workRecordWrap mainPageBg" v-loading="$store.state.user.loadingState">
    <div class="recordContent commonOrderContent">
      <div class="formBox recordContent-top">
        <DatePickerRange @dateChange="dateChange" :size="'mini'" />
        <div><el-button type="primary" size="mini" @click="currentPage = 1;
        getAllList();
                                                                                                      ">查询</el-button>
          <el-button type="primary" size="mini" plain @click=" exportExcel "><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
        </div>
      </div>
      <div class="tabCardBox recordContent-content">
        <el-table ref="drawTable" :data=" tableData " stripe border style="width: 100%" class="tabWrap" height="90%"
          :header-cell-style=" { 'background-color': '#F7F7F7' } " :cell-style=" cellStyle "
          @selection-change=" handleSelectionChange " :row-key=" getRowKeys ">
          <el-table-column type="selection" width="50" align="center" reserve-selection>
          </el-table-column>
          <el-table-column prop="id" label="工单ID" align="center">
          </el-table-column>
          <el-table-column prop="time" label="创建时间" align="center">
          </el-table-column>
          <el-table-column prop="description" label="工单名称" align="center">
            <template slot-scope="scope">
              <span v-if=" scope.row.description && scope.row.description.length >= 8 ">
                <el-tooltip class="item" effect="dark" :content=" scope.row.description " placement="top-start">
                  <div>{{ scope.row.description }}</div>
                </el-tooltip>
              </span>
              <span v-else>{{ scope.row.description }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="level" label="工单级别" align="center" min-width="60" :show-overflow-tooltip=" true ">
          </el-table-column>
          <el-table-column prop="remark" label="工单描述" align="center">
            <template slot-scope="scope">
              <span v-if=" scope.row.remark && scope.row.remark.length >= 10 ">
                <el-tooltip class="item" effect="dark" :content=" scope.row.remark " placement="top-start">
                  <div>{{ scope.row.remark }}</div>
                </el-tooltip>
              </span>
              <span v-else>{{ scope.row.location }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="setStatus" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag size="medium" :type="
                scope.row.setStatus == '待派单' ||
                  scope.row.setStatus == '已关闭'
                  ? 'info'
                  : scope.row.setStatus == '待处理'
                    ? 'warning'
                    : scope.row.setStatus == '待重新派单'
                      ? 'danger'
                      : scope.row.setStatus == '已完成'
                        ? 'success'
                        : ''
              ">{{ scope.row.setStatus }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="handlers" label="处理人" align="center" min-width="60"
            :show-overflow-tooltip=" true "></el-table-column>
          <el-table-column label="操作" :width=" cloumnWidth() " align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click=" detailsProcessing(scope.row, '详情') ">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change=" handleSizeChange " @current-change=" handleCurrentChange " :current-page=" currentPage "
          :page-sizes=" [10, 30, 50] " :page-size=" page.size " layout="total, sizes, prev, pager, next, jumper"
          :total=" page.total " style="margin-top: 10px; text-align: right">
        </el-pagination>
      </div>
    </div>
    <!-- 创建工单 -->
    <!-- <DialogForm :dialogVisible="dialogVisible" v-if="dialogVisible" :selectItem="selectItem" :userAllList="userAllList" /> -->
    <!-- 工单详情 -->
    <el-drawer :visible.sync=" drawerState " v-if=" orderDetails " title="详情" class="drawerWrap" size="30%"
      :before-close=" handleClose ">
      <OrderDetails :activeItem=" selectItem " />
    </el-drawer>
    <!-- 操作确认框 -->
    <HandleDialogCom v-if=" handleDialog " :activeItem=" selectItem " :userAllList=" userAllList " />
  </div>
</template>

<script>
import DialogForm from "@/components/houqinguanli/gongdanguanli/DialogForm.vue";
import HandleDialogCom from "@/components/houqinguanli/gongdanguanli/HandleDialogCom.vue";
import OrderDetails from "@/components/houqinguanli/gongdanguanli/OrderDetails";
import DatePickerRange from '@/components/DatePicker/DatePickerRange';
import api from "@/api";
import {
  dateFtt,
  matchingOrderLevel,
  matchingOrderStatus,
  matchingOrderColor,
  exportExcelFun,
} from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  name: "WorkRecord",
  props: {
    activeItem: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    DatePickerRange,
    DialogForm,
    HandleDialogCom,
    OrderDetails,
  },
  data() {
    return {
      startTime: this.$moment().startOf("day").format("x"),
      endTime: this.$moment(new Date()).format("x"),
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      orderDetails: false,
      drawerState: false,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      selectItem: {},
      multipleSelection: [],
      handleDialog: false,
      roleAuthority: false,
    };
  },
  methods: {
    dateChange(value) {
      this.startTime = this.$moment(value[0]).startOf('day').format('x')
      this.endTime = this.$moment(value[1]).endOf('day').format('x')
    },
    cloumnWidth() {
      if (this.roleAuthority) {
        return 200;
      } else {
        return 70;
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    // 批量操作
    batchOperation() {
      this.selectItem = this.multipleSelection;
      if (this.selectItem.length == 0) {
        this.$message.error("未选择工单!");
        return;
      }
      this.handleDialog = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleClose() {
      this.orderDetails = false;
      this.drawerState = false;
    },
    detailsProcessing(row, type) {
      this.selectItem = row;
      this.selectItem.clickType = type;
      this.orderDetails = true;
      this.$nextTick(() => {
        this.drawerState = true;
      });
    },
    cellStyle(row) {
      if (row.column.label === "工单级别") {
        return matchingOrderColor(row.row.priority);
      }
      if (row.column.label === "创建时间") {
        return "font-size:12px";
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getAllList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAllList();
    },
    async getAllList() {
      this.tableData = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.DMFindWorkOrderList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        textSearch: this.activeItem?.id?.id || this.activeItem?.deviceId,
        startTs: this.startTime,
        endTs: this.endTime,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data.data;
        this.page.total = res.data.data.totalElements;
        this.tableData.forEach((v) => {
          v.time = v.createdTime
            ? dateFtt("yyyy-MM-dd hh:mm", new Date(v.createdTime))
            : "";
          v.handlers = v.assignStaffNames.join("、");
          v.level = matchingOrderLevel(v.priority);
          v.setStatus = matchingOrderStatus(v.status);
        });
      }
    },
    exportExcel() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("没有可导出的数据!");
        return false;
      }
      let excelTitle = `${this.activeItem?.name || ""}工单记录_${this.$moment(
        Number(this.startTime)
      ).format("yyyy-MM-DD")}-${this.$moment(Number(this.endTime)).format(
        "yyyy-MM-DD"
      )}`;
      let tabHeader = [
        { label: "工单ID", prop: "id" },
        { label: "创建时间", prop: "time" },
        { label: "工单名称", prop: "description" },
        { label: "工单级别", prop: "level" },
        { label: "工单描述", prop: "remark" },
        { label: "状态", prop: "setStatus" },
        { label: "处理人", prop: "handlers" },
      ];

      exportFile.xlsxFile(XLSX, excelTitle, {
        excel: exportExcelFun(tabHeader, this.multipleSelection),
      });
    },
  },
  created() {
    this.getAllList();
  },
};
</script>

<style lang="scss" scoped>
.workRecordWrap {
  @include setFlexCenter;

  ::v-deep .cell {
    .el-tooltip {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }

  .recordContent {
    width: 100%;
    height: 100%;

    ::v-deep .el-select .el-input {
      width: 120px;
    }

    ::v-deep .el-tabs__content {
      height: calc(100% - 50px);
    }

    &-top {
      @include setFlexBetween;
      width: 96%;
      margin: 0 auto;
      height: 50px;
    }

    &-content {
      height: calc(100% - 60px);
    }
  }

  ::v-deep .el-descriptions {
    th {
      width: 120px;
    }
  }
}
</style>